module.exports = __webpack_public_path__ + "img/select.f10367b6.png";